import { InfoCircleOutlined } from "@ant-design/icons";
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Button,
  Collapse,
  Divider,
  Input,
  message,
  Modal,
  Popconfirm,
  Popover,
  Row,
  Select,
  Space,
  Spin,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";

import { getSupaClient, getWorkspace } from "../../lib/supabase";
import { SlackEditorPreview } from "../TextEditor/SlackEditor";

const { Option } = Select;
const { Panel } = Collapse;

const Templates = (props) => {
  // props.onInsert: a function to call in the parent when a template is inserted, using the template text as input.
  // props.newText: a string representing a new template
  const supabase = getSupaClient();
  const workspace = getWorkspace(supabase);
  const teamId = localStorage.getItem("team-id");
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [selectedTemplateText, setSelectedTemplateText] = useState("");
  const [newTemplateName, setNewTemplateName] = useState("");

  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewMessage, setPreviewMessage] = useState({ html: "" });

  const pullTemplates = async () => {
    const { data, error } = await supabase
      .from("message_templates")
      .select("*");
    if (error) console.log("error in pullTemplates", error);
    else {
      setTemplates(data);
    }
    setLoading(false);
  };

  useEffect(() => {
    pullTemplates();
  }, []);

  const renderTemplatePreview = (text) => {
    const cutOffLength = 40;
    if (text.length <= cutOffLength) return text;
    return `${text.slice(0, cutOffLength)}...`;
  };

  const onTemplateSelect = (id) => {
    setSelectedTemplateId(id);
    const template = templates.find((t) => t.id === id);
    setSelectedTemplateText(template.text);
    setPreviewMessage({ html: template.text });
  };

  const onTemplateInsert = () => {
    props.onInsert(selectedTemplateText);
    setVisible(false);
  };

  const deleteTemplate = async (id) => {
    const { data, error } = await supabase
      .from("message_templates")
      .delete()
      .match({ id: selectedTemplateId });
    if (error) {
      console.log("error deleting template", error);
      message.success("Error deleting template");
    } else {
      message.success("Deleted template");
      pullTemplates();
      setSelectedTemplateId(null);
      setSelectedTemplateText("");
    }
  };

  const onNameChange = (event) => {
    // console.log("val", val);
    setNewTemplateName(event.target.value);
  };

  const onCreateTemplate = async () => {
    if (props.newText.length === 0) {
      message.error("Please provide text for template!");
      return;
    }
    const { data, error } = await supabase.from("message_templates").insert([
      {
        name: newTemplateName,
        text: props.newText,
        team: teamId,
        workspace,
      },
    ]);
    if (error) {
      console.log("error in onCreateTemplate", error);
      message.error("Error creating template.");
    } else {
      setNewTemplateName("");
      pullTemplates();
      setSelectedTemplateId(data[0].id);
      setSelectedTemplateText(data[0].text);
      setPreviewMessage({ html: props.newText });
      message.success("Successfully created template!");
    }
    setLoading(false);
  };

  const showPreview = (text) => {
    setPreviewVisible(true);
    setPreviewMessage({ html: text });
  };

  const content = (
    <Spin spinning={loading}>
      Use an existing template
      <Row style={{ marginTop: 10 }}>
        <Select
          style={{ width: 500 }}
          placeholder="Exisiting template"
          dropdownRender={(menu) => (
            <div>
              {menu}
              <Divider style={{ margin: "4px 0" }} />
            </div>
          )}
          onSelect={onTemplateSelect}
          value={selectedTemplateId}
        >
          {templates.map((template) => (
            <Option key={template.id} value={template.id}>
              <div>
                <b>{template.name}</b>
              </div>
            </Option>
          ))}
        </Select>
      </Row>
      <Row style={{ marginTop: 20 }}>
        <div style={{ width: "500px" }}>
          <SlackEditorPreview message={previewMessage} />
        </div>
      </Row>
      <Row style={{ marginTop: 10 }}>
        <Space>
          <Button
            disabled={selectedTemplateText.length === 0}
            onClick={onTemplateInsert}
          >
            Insert
          </Button>
          <Popconfirm
            title="Delete this template?"
            onConfirm={() => {
              deleteTemplate();
            }}
            disabled={selectedTemplateId === null}
          >
            <Button disabled={selectedTemplateId === null} type="default">
              Delete
            </Button>
          </Popconfirm>
        </Space>
      </Row>
      <Collapse style={{ marginTop: 20 }}>
        <Panel header="Or create a new template using what you've typed out">
          <Row>
            <Input
              style={{ width: 400 }}
              placeholder="Name"
              onChange={onNameChange}
              value={newTemplateName}
            />
            <Button
              type="primary"
              onClick={onCreateTemplate}
              disabled={newTemplateName.length === 0}
            >
              Create
            </Button>
          </Row>
        </Panel>
      </Collapse>
    </Spin>
  );

  return (
    <div>
      <Row>
        <Popover
          style={{ width: 700 }}
          content={content}
          title="Templates"
          placement="leftBottom"
          trigger="click"
          visible={visible}
          onVisibleChange={setVisible}
        >
          <Button>Templates</Button>
        </Popover>
      </Row>
    </div>
  );
};

export default Templates;
